(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lampora-test-terrain"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGalerie(g) {
      if (g.dataset.lamporaPret) return;
      g.dataset.lamporaPret = '1';
      var piste = g.querySelector('.lampora-galerie__piste');
      var nb = piste.children.length;
      var points = g.querySelectorAll('.lampora-galerie__point');
      var prec = g.querySelector('[data-prec]');
      var suiv = g.querySelector('[data-suiv]');
      function actuel() { return Math.round(piste.scrollLeft / piste.clientWidth); }
      function aller(i) { piste.scrollTo({ left: Math.max(0, Math.min(nb - 1, i)) * piste.clientWidth, behavior: 'smooth' }); }
      function maj() {
        var i = actuel();
        points.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prec) prec.disabled = i <= 0;
        if (suiv) suiv.disabled = i >= nb - 1;
      }
      if (prec) prec.addEventListener('click', function () { aller(actuel() - 1); });
      if (suiv) suiv.addEventListener('click', function () { aller(actuel() + 1); });
      points.forEach(function (p) { p.addEventListener('click', function () { aller(parseInt(p.dataset.index, 10)); }); });
      piste.addEventListener('scroll', function () { window.requestAnimationFrame(maj); }, { passive: true });
      maj();
    }
    function init() { document.querySelectorAll('[data-lampora-galerie]').forEach(initGalerie); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
